export const stConfig = {
  experimentName: 'se_StylablePanelExperimentVersion',
  experimentVersion: '2.3.2',
  themeName: 'santa-editor-design-panel',
  themeVersion: '1.0.45',
  modulePath: 'https://static.parastorage.com/unpkg/@wixc3',
};
